import { Component } from '@angular/core';
import { UrlService } from '../services/url.service';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss'],
  standalone: false
})
export class TermsComponent {

  constructor(public urlService: UrlService) {}

  getCurrentDate(): string {
    return new Date().toLocaleDateString();
  }

  /**
   * Get the base URL for generating component URLs
   */
  getBaseUrl(): string {
    return this.urlService.getBaseUrl();
  }

  /**
   * Get the Privacy Policy URL
   */
  getPrivacyUrl(): string {
    return this.urlService.getPrivacyUrl();
  }

  /**
   * Get the Terms URL (current page)
   */
  getTermsUrl(): string {
    return this.urlService.getTermsUrl();
  }

}
